/* eslint-disable */

import AngerIcon from "../../assets/icons/anger.png"
import AnxietyIcon from "../../assets/icons/anxiety.png"
import FearIcon from "../../assets/icons/fear.png"
import JoyIcon from "../../assets/icons/joy.png"
import LoveIcon from "../../assets/icons/love.png"
import SadnessIcon from "../../assets/icons/sadness.png"
import ShameIcon from "../../assets/icons/shame.png"

/** 1) Data **/
export const emotionLabels = ['Anger', 'Anxiety', 'Fear', 'Joy', 'Love', 'Sadness', 'Shame'];
const dataVals = [11, 64, 25];
const colors = ['#39F6C6', '#7C9BFF', '#FFB84D'];

// One image per label (use your own emoji/image URLs)
export const emotionImageMap = {
	Anger: AngerIcon,
	Anxiety: AnxietyIcon,
	Fear: FearIcon,
	Joy: JoyIcon,
	Love: LoveIcon,
	Sadness: SadnessIcon,
	Shame: ShameIcon
};

export const emotionColorMap = {
	Anger: "red",
	Anxiety: "teal",
	Fear: "dark-gray",
	Joy: "yellow",
	Love: "pink",
	Sadness: "lightblue",
	Shame: "purple"
};

// Preload images
export const piechartLabelImages = (labels, imageMap) => labels.map(l => {
  const im = new Image();
  im.src = imageMap[l];
  return im;
});

export const imageUrlsToImage = (urls) => urls.map(url => {
  const img = new Image();
  img.src = url;
  return img;
});

/** 2) Custom label plugin **/
export const outsideLabelPlugin = {
  id: 'outsideLabelPlugin',
  afterDatasetsDraw(chart, args, pluginOpts) {
    const { ctx } = chart;
    const meta = chart.getDatasetMeta(0);
    if (!meta || !meta.data) return;

	const {
		distFromCenter,
		images
	} = chart.config.options.plugins.outsideLabelPlugin;

    const ds = chart.data.datasets[0];
    const values = ds.data;

    meta.data.forEach((arc, i) => {
      // Arc middle angle and anchor point
      const angle = (arc.startAngle + arc.endAngle) / 2;
      const cosA = Math.cos(angle);
      const sinA = Math.sin(angle);
      const anchorRadius = arc.outerRadius + (distFromCenter || 26); // how far outside the pie
      const anchorX = arc.x + cosA * anchorRadius;
      const anchorY = arc.y + sinA * anchorRadius;

      // Side-aware layout (labels on left align right, on right align left)
      const onLeft = cosA < 0;
      const dotR = 6;
      const gap = 12; // spacing between items
      const imgSize = 48;

      // Horizontal positions depend on side
      let x = anchorX + (onLeft ? -dotR : dotR);
      const textAlign = onLeft ? 'left' : 'left';

      ctx.save();
      ctx.textBaseline = 'middle';
      ctx.textAlign = textAlign;

      // 2) image (emoji)
      const img = images[i];
      if (img && img.complete) {
        const imgX = onLeft ? (x - gap - 2 * imgSize - 10) : (x + gap);
        const imgY = anchorY - imgSize / 2;
        ctx.drawImage(img, imgX, imgY, imgSize, imgSize);
        // move text start past the image
        x = onLeft ? (imgX + imgSize + gap) : (imgX + imgSize + gap);
      } else {
        // no image loaded yet—just nudge text a bit
        x = onLeft ? (x - gap) : (x + gap);
      }

      // 3) text: Title (top) + Percent (bottom)
      const label = chart.data.labels[i];
      const pct = values[i] + '%';

      // 1) colored dot (same color as slice)
      ctx.beginPath();
      ctx.arc(onLeft ? x : x + (dotR/2) + 2, anchorY - 10, dotR, 0, Math.PI * 2);
      ctx.fillStyle = ds.backgroundColor[i];
      ctx.fill();

      // Title
      ctx.font = '600 18px system-ui, -apple-system, Segoe UI, Roboto, Inter, sans-serif';
      ctx.fillStyle = '#0f172a';
      ctx.fillText(label, x + dotR + gap, anchorY - 10);

      // Percent
      ctx.font = '500 16px system-ui, -apple-system, Segoe UI, Roboto, Inter, sans-serif';
      ctx.fillStyle = '#475569';
      ctx.fillText(pct, x, anchorY + 10);

      ctx.restore();
    });
  }
};